import classNames from "classnames";
import { Button } from "PFComponents/button";
import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { prune, truncate } from "underscore.string";

import { Typography } from "../typography";
import css from "./toggleable_text.module.scss";

type ToggleableTextProps = {
  text?: string;
  toggleLength?: number;
  shortLengthFactor?: number;
  sameLine?: boolean;
};

export const ToggleableText = ({
  text,
  toggleLength = 200,
  shortLengthFactor = 1.25,
  sameLine = true
}: ToggleableTextProps) => {
  const { t } = useTranslation("core");
  const [showAll, setShowAll] = useState<boolean>(false);
  const isShort: boolean = text ? text.length < toggleLength * Math.min(1, shortLengthFactor) : true;

  const preparedText = useMemo<string>(() => {
    let raw = (text || "").trim();
    if (!isShort && !showAll) {
      raw = raw.split(" ")[0].length > toggleLength ? truncate(raw, toggleLength) : prune(raw, toggleLength);
    }

    return raw.replace(/\n\n+/g, "\n\n");
  }, [isShort, showAll, text, toggleLength]);

  return (
    <div className={css.root}>
      <Typography withMargin variant="bodyRegular" tag="span">
        {preparedText}
      </Typography>
      {!sameLine && <br />}
      {text && !isShort && (
        <Button
          kind="text"
          className={classNames(css.more, { [css.sameLine]: sameLine })}
          onClick={() => {
            setShowAll(!showAll);
          }}
        >
          {showAll ? `${t("less")}...` : `${t("more")}...`}
        </Button>
      )}
    </div>
  );
};
